import { EvaluationCriteriaItemForm } from '@/module/Evaluation/form/EvaluationCriteriaItemForm';
import { useEvaluationAddCriteriaItem } from '@/module/Evaluation/model/EvaluationQuery';
import {
  EvaluationCriteriaDataItemRequest,
  EvaluationCriteriaDiscriminator,
  EvaluationCriteriaType,
} from '@/module/Evaluation/model/EvaluationTypes';

import { Id, useAppNotification } from '@feature/utils';

interface EvaluationCriteriaItemCreateProps {
  close: () => void;
  discriminatorList: EvaluationCriteriaDiscriminator[];

  evaluationId: Id;
  authorId: Id;
  orderNo: number;

  criteriaType: EvaluationCriteriaType;

  dataEntryHint: string | null;

  alreadySelectedIds: number[];
}

const defaultValues = {
  link: '',
  note: '',
  activityDescription: '',
  number: 0,
};

export function EvaluationCriteriaItemCreate(props: EvaluationCriteriaItemCreateProps) {
  const { close, evaluationId, authorId, orderNo, discriminatorList, criteriaType, dataEntryHint, alreadySelectedIds } =
    props;
  const { mutate, isPending } = useEvaluationAddCriteriaItem(evaluationId, authorId, orderNo);
  const notification = useAppNotification();

  const onSubmit = (values: EvaluationCriteriaDataItemRequest) => {
    mutate(
      {
        ...values,
        criteriaType,
      },
      {
        onSuccess: () => {
          notification.success();
          close();
        },
        onError: notification.error,
      },
    );
  };

  return (
    <EvaluationCriteriaItemForm
      onCancel={close}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      criteriaType={criteriaType}
      discriminatorList={discriminatorList}
      dataEntryHint={dataEntryHint}
      evaluationId={evaluationId}
      authorId={authorId}
      orderNo={orderNo}
      alreadySelectedIds={alreadySelectedIds}
    />
  );
}
